// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../utils/createApi";
import { getRefreshToken } from "../../../utils/getRefreshToken";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { MobotixTab } from "../MobotixTab";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const handleAddAction = (
  cameraId: string,
  navigate: NavigateFunction,
  setBackdropLoadingScreenOn: Dispatcher<boolean>,
  setIPNotifyData: any,
  setActiveTab: any,
  timeTablesData: any,
  setTimeTablesData: any,
  iPNotifyData: any,
  setActionHandlerData: any
) => {
  const AxiosUI = createApi("");

  const retryFunction = () => {
    handleAddAction(
      cameraId,
      navigate,
      setBackdropLoadingScreenOn,
      setIPNotifyData,
      setActiveTab,
      timeTablesData,
      setTimeTablesData,
      iPNotifyData,
      setActionHandlerData
    );
  };

  AxiosUI.post(`/mobotix/${cameraId}/action_handler/`, {}).then(
    (response: AxiosResponse) => {
      setActionHandlerData(response.data);
      setBackdropLoadingScreenOn(false);
      setActiveTab(<></>);
      setActiveTab(
        <MobotixTab
          timeTablesData={timeTablesData}
          navigate={navigate}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setTimeTablesData={setTimeTablesData}
          setActiveTab={setActiveTab}
          iPNotifyData={iPNotifyData}
          setIPNotifyData={setIPNotifyData}
          actionHandlerData={response.data}
          setActionHandlerData={setActionHandlerData}
        />
      );
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setBackdropLoadingScreenOn(false);
        alert("Problem adding Action, please try again");
      });
    }
  );
};
